import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'
import { formatHours } from '../../../helpers/timesheet'
import { TimeByActivity } from './TimeByActivity'
import type { HoursByTask } from './types'

/** "Total Hours" block: total badge + per-task pills (v1). */
export const TimeActivitySummary = ({
  totalMinutes,
  hoursByTask,
  fetching,
}: {
  totalMinutes: number
  hoursByTask: HoursByTask[]
  fetching: boolean
}) => {
  const { _ } = useLingui()
  return (
    <div className='tc-history-block'>
      <div className='tc-history-row'>
        <div className='tc-history-heading'>{_(msg`Total Hours`)}</div>
        <span className='tc-total-badge'>
          {fetching ? '—' : formatHours(totalMinutes)}
        </span>
      </div>
      <TimeByActivity hoursByTask={hoursByTask} />
    </div>
  )
}
